import React from 'react';
import { Box, Typography, Container, Grid, Stack } from '@mui/material';
import { styled, keyframes } from '@mui/system';
import RocketLaunchIcon from '@mui/icons-material/RocketLaunch';
import CustomButton from './Styled3DButton'; 

// 3D Image Animation
const float = keyframes`
  0% { transform: translateY(0px) rotate(0deg); }
  50% { transform: translateY(-20px) rotate(5deg); }
  100% { transform: translateY(0px) rotate(0deg); }
`;

const ImageFrame = styled(Box)(({ theme }) => ({
  width: '100%',
  maxWidth: '450px',
  height: '450px',
  borderRadius: '30% 70% 70% 30% / 30% 30% 70% 70%', // Blob Shape
  background: 'linear-gradient(135deg, #1976d2 0%, #64b5f6 100%)',
  position: 'relative',
  boxShadow: '0 25px 50px rgba(0,0,0,0.5), inset 0 0 20px rgba(255,255,255,0.3)',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  animation: `${float} 6s ease-in-out infinite`,
  overflow: 'hidden',
  border: '5px solid rgba(255,255,255,0.1)',
  '& img': {
    width: '105%',
    height: '105%',
    objectFit: 'cover',
  }
}));

const HomeHero = () => {
  return (
    <Box sx={{ 
      minHeight: '93vh', 
      display: 'flex', 
      alignItems: 'center', 
      background: 'radial-gradient(circle at 20% 50%, #1e293b 0%, #0f172a 100%)',
      overflow: 'hidden',
      position: 'relative',
      py: { xs: 8, md: 0 }
    }}>
      {/* Background Decorative Circles */}
      <Box sx={{
        position: 'absolute',
        width: '500px',
        height: '500px',
        background: 'radial-gradient(circle, rgba(25, 118, 210, 0.2) 0%, transparent 70%)',
        top: '-10%',
        right: '-5%',
        zIndex: 1
      }} />

      <Container maxWidth="lg">
        <Grid container spacing={11} alignItems="center">
          
          {/* LEFT SIDE: CONTENT */}
          <Grid item xs={12} md={7} sx={{ zIndex: 2 }}>
            <Stack spacing={3} alignItems={{ xs: 'center', md: 'flex-start' }} textAlign={{ xs: 'center', md: 'left' }}>
              <Typography variant="overline" sx={{ color: '#64b5f6', fontWeight: 800, letterSpacing: 4 }}>
                WELCOME TO MY PORTFOLIO
              </Typography>
              
              <Typography variant="h1" sx={{ 
                fontWeight: 900, 
                color: '#fff', 
                fontSize: { xs: '3rem', md: '4.5rem' },
                lineHeight: 1.1,
                textShadow: '0 10px 20px rgba(0,0,0,0.3)' 
              }}>
                Vikash <br />
                <span style={{ color: '#1976d2' }}>Tiwari</span> 
              </Typography>

              <Typography variant="h4" sx={{ color: 'rgba(255,255,255,0.8)', fontWeight: 600 }}>
                Software Developer 
              </Typography>

              <Typography variant="body1" sx={{ 
                color: 'rgba(255,255,255,0.6)', 
                maxWidth: '600px', 
                fontSize: '1.1rem',
                lineHeight: 1.8 
              }}>
                I am a dedicated App Developer with strong skills in Java, Kotlin, Jetpack Compose, and Flutter for mobile and PC applications. 
              </Typography>

              <Box sx={{ mt: 2 }}>
                <CustomButton 
                  title="Explore Projects" 
                  startIcon={<RocketLaunchIcon />}
                  onClick={() => window.location.href = '/portfolio'}
                />
              </Box>
            </Stack>
          </Grid>

          {/* RIGHT SIDE: IMAGE */}
          <Grid item xs={12} md={5} sx={{ display: 'flex', justifyContent: 'center', zIndex: 2 }}>
            <Box sx={{ position: 'relative' }}>
              {/* Image Frame with 3D Float */}
              <ImageFrame>
                <img 
                  src="https://d1rluokkqqu56n.cloudfront.net/wpapp/uploads/2023/03/01115341/les-metiers-de-la-techjpeg.jpeg" // Yahan apni image ka path daalein
                  alt="Vikash Tiwari" 
                />
              </ImageFrame>
              
              {/* Decorative Ring around image */}
              <Box sx={{
                position: 'absolute',
                top: '-20px',
                left: '-20px',
                right: '-20px',
                bottom: '-20px',
                border: '2px dashed rgba(25, 118, 210, 0.3)',
                borderRadius: '50%',
                animation: 'spin 20s linear infinite',
                '@keyframes spin': {
                  '0%': { transform: 'rotate(0deg)' },
                  '100%': { transform: 'rotate(360deg)' }
                }
              }} />
            </Box>
          </Grid>

        </Grid>
      </Container>
    </Box>
  );
};

export default HomeHero;